import { LoadingButton } from '@mui/lab';
import { DialogActions, Grid, Button } from '@mui/material';

export type DataFocusViewDialogActionsProps = {
    onSubmit: () => Promise<any>;
    onClose: (record?: any) => void;
    isSubmitting?: boolean;
    isSubmitDisabled?: boolean;
};

export const DataFocusViewDialogActions = ({ onSubmit, onClose, isSubmitting, isSubmitDisabled }: DataFocusViewDialogActionsProps) => (
    <DialogActions sx={{ px: '24px', display: 'flex', justifyContent: 'space-between', height: '64px', bgcolor: '#f5f6f7' }}>
        <Grid item xs="auto">
            <Button
                variant="outlined"
                onClick={() => onClose()}
                color="secondary"
                sx={{ width: '80px', height: '32px', borderRadius: '8px' }}
            >
                Close
            </Button>
        </Grid>
        <Grid item xs="auto">
            <LoadingButton
                loading={isSubmitting}
                onClick={async () => {
                    const record = await onSubmit();
                    if (record) onClose(record);
                }}
                disabled={isSubmitDisabled || isSubmitting}
                variant="contained"
                color="secondary"
                sx={{ height: '32px', borderRadius: '8px' }}
            >
                Save
            </LoadingButton>
        </Grid>
    </DialogActions>
);
